module.exports = __webpack_public_path__ + "fiji.svg?1deb6f70a160a3e8448070e6bda05136";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/fiji.svg
// module id = 165
// module chunks = 10